import { CallDirectionTypes, CallRetentionPolicyTypes } from 'generated/graphql-types';

export function setHideRecordingDate(callRetentionPolicyTypeId: CallRetentionPolicyTypes | null): string {
   const currentDate = new Date();
   let hideDate: Date;

   switch (callRetentionPolicyTypeId) {
      case CallRetentionPolicyTypes.Eighteen:
         hideDate = new Date(currentDate.setMonth(currentDate.getMonth() - 18));
         break;
      case CallRetentionPolicyTypes.Sixty:
         hideDate = new Date(currentDate.setMonth(currentDate.getMonth() - 60));
         break;
      case CallRetentionPolicyTypes.ThirtySix:
         hideDate = new Date(currentDate.setMonth(currentDate.getMonth() - 36));
         break;
      case CallRetentionPolicyTypes.NegativeOne:
         hideDate = new Date('0000-01-01T00:00:00.000Z');
         break;
      default:
         hideDate = new Date('0000-01-01T00:00:00.000Z');
         break;
   }

   return hideDate.toISOString();
}

export function getCallExtension(
   extension: { number?: number | undefined; name?: string | null },
   callDirectionTypeId: CallDirectionTypes | null | undefined,
   phoneNumber: string | null,
   isCallDestination = false
): string {
   const isOutbound = callDirectionTypeId === CallDirectionTypes.Outbound;
   const isInbound = callDirectionTypeId === CallDirectionTypes.Inbound;

   if (isOutbound) {
      if (isCallDestination && phoneNumber?.length && phoneNumber.length > 5) {
         return phoneNumber ?? '';
      } else {
         if (extension?.number !== undefined) {
            return formatExtension(extension);
         }
         return phoneNumber ?? '';
      }
   }

   if (isInbound) {
      if (isCallDestination) {
         if (extension?.number !== undefined) {
            return formatExtension(extension);
         }
         return phoneNumber ?? '';
      } else {
         return phoneNumber ?? '';
      }
   }

   if (phoneNumber && extension.number === undefined) {
      return phoneNumber;
   } else {
      return formatExtension(extension);
   }
}

function formatExtension(extension: { number?: number; name?: string | null }): string {
   let extensionDisplay = '';
   if (extension.number) {
      extensionDisplay += `${extension.number}`;
   }
   if (extension.name) {
      extensionDisplay += ` - ${extension.name}`;
   }
   return extensionDisplay;
}
